import $ from 'jquery';
import noUiSlider from 'nouislider';
import wNumb from 'wnumb';

$('.js-range').each((index, range) => {
  const $range = $(range);
  const $rangeMin = $range.find('.js-range-min');
  const $rangeMax = $range.find('.js-range-max');
  const $rangeNouislider = $range.find('.js-range-nouislider');

  const min = Number($rangeMin.text());
  const max = Number($rangeMax.text());

  noUiSlider.create($rangeNouislider[0], {
    connect: true,
    tooltips: wNumb({
      decimals: 0,
    }),
    format: wNumb({
      decimals: 0,
    }),
    start: [Math.max(min, max - 5), max],
    range: { min, max },
    step: 1,
  });

  $rangeNouislider[0].noUiSlider.on('update', () => {
    const values = $rangeNouislider[0].noUiSlider.get();
    $range.attr('data-value-min', values[0]);
    $range.attr('data-value-max', values[1]);
    $range.trigger('change', values);
  });
});
